import { Enrolment } from '@/models/enrolment';
import { EnrolmentStatus } from '@/models/enrolment-status';
import EnrolmentService from '@/services/enrolments-service';

import { TransitionTrigger } from './transition-trigger';

export class EnrolmentAlreadyProcessedTrigger extends TransitionTrigger {
	public orderingNumber = 101;

	public constructor(excludedEnrolmentStatuses: EnrolmentStatus[]) {
		super('Duplicated', excludedEnrolmentStatuses);
	}

	public equals(that: TransitionTrigger): boolean {
		return that instanceof EnrolmentAlreadyProcessedTrigger;
	}

	protected async performTransitions(enrolments: Readonly<Enrolment[]>): Promise<void> {
		await EnrolmentService.triggerEnrolmentAlreadyProcessed(enrolments);
	}
}
